import React from 'react'
import PT from 'prop-types'
import cx from 'classnames'

import styles from './styles.css'

const Err = ({ children, className }) => (
  <p className={cx(styles.error, className)}>
    {children}
  </p>
)

Err.propTypes = {
  children: PT.node,
  className: PT.string,
}

export default Err
